<script lang="ts">
import { createEventDispatcher } from "svelte";


    export let donut: {
        from: number;
        to: number;
        n: number;
    } = { from: 0, to: 0, n: 0 };

    const remove = createEventDispatcher();
    function onRemove(): void {
        remove("remove");
    }
</script>

<li class="list-group-item p-1 d-flex g-0 w-100 justify-content-between">
    <div class="d-flex ps-2 movement-illustration">
        <div class="text-black">
            <input
                class="count"
                type="number"
                min="0"
                step="100"
                bind:value={donut.from} />
        </div>
        <div class="text-black px-1">
            <i class="fe fe-arrow-right" />
        </div>
        <div class="text-black">
            <input
                class="count"
                type="number"
                min="0"
                step="100"
                bind:value={donut.to} />
        </div>
    </div>
    <div class="d-flex">
        <input
            class="count"
            type="number"
            min="0"
            step="10"
            bind:value={donut.n} />
    </div>
    <div class="d-flex">
        <div class="text-grey px-1 pt-1" on:click={() => onRemove()}>
            <i class="fe fe-trash-2" />
        </div>
    </div>
</li>

<style>
    .movement-illustration {
        width: 100px;
    }

    .count {
        width: 75px;
    }
</style>
